import React from 'react';
import { useSelector } from 'react-redux';
import { withInjectedProps } from '../../../Core/InjectedPropsContext';
import { Field, NumericInput, TextOutput, RadioGroup } from '../../../Core';
import { PageSection, ListFieldSection } from '../../../Layout';
import { WorksheetAssociatedTestSection } from '../../Core';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { Guid } from 'Lib/Guid';

let TestFractionSpecificGravitySection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const determinationMethod = useSelector(createWorksheetSelector!('DeterminationMethod')) as string;
  const importedTestId = useSelector(createWorksheetSelector!('AssociatedSpecificGravity.ImportedTest.Id')) as Guid;
  const assumedSpecificGravity = useSelector(createWorksheetSelector!('AssumedSpecificGravity')) as number;

  return (
    <PageSection heading="Test Fraction Specific Gravity">
      <ListFieldSection>
        <Field
          input={<RadioGroup />}
          label="Determination Method"
          name={'DeterminationMethod'}
          confirm={() => (determinationMethod === 'assumed' ? !!assumedSpecificGravity : true)}
          confirmTitle="Confirm Determination Change"
          confirmText="Any existing data for this results determination will be removed."
          confirmButtonText="Change Determination"
          options={[
            { label: 'Assumed', value: 'assumed' },
            { label: 'Measured', value: 'measured' },
          ]}
        />
        <Field
          input={<NumericInput />}
          label="Test Fraction Specific Gravity"
          name={'AssumedSpecificGravity'}
          visible={determinationMethod === 'assumed'}
        />
      </ListFieldSection>

      <WorksheetAssociatedTestSection
        visible={determinationMethod === 'measured'}
        label="Determined By:"
        name="AssociatedSpecificGravity"
        testType="Specific Gravity Coarse"
        associatedTestModel={{
          imported: {
            importedTestResults: (
              <ListFieldSection>
                <Field input={<TextOutput />} label="Test Fraction Specific Gravity" name={'SpecificGravity'} emph />
              </ListFieldSection>
            ),
            importModel: {
              Id: importedTestId,
            },
          },
          external: {
            // note: testMethods are defined in config as component is shared and standards use different tests
            externalTestResults: (
              <ListFieldSection>
                <Field
                  input={<NumericInput />}
                  label="Test Fraction Specific Gravity"
                  name={'AssociatedSpecificGravity.ExternalTest.Results.SpecificGravityOvenDry'}
                />
              </ListFieldSection>
            ),
          },
        }}
      />
    </PageSection>
  );
};

TestFractionSpecificGravitySection = withInjectedProps(TestFractionSpecificGravitySection);

export { TestFractionSpecificGravitySection };
